<template>
    <modal id="finance-advance-payment-status-modal"
           v-model="showModal"
           size="large"
           :title="$t('advance_payment')"
           @submit="submitData"
           :loading="loading"
           :preloader="preloader">

        <form @submit.prevent="submitData">
            <div class="row">
                <div class="col-md-12">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('status')"
                        v-model="formData.status"
                        :options="statusOptions"
                        list-value-field="name"
                        :chooseLabel="$t('status')"
                        :error-message="$errorMessage(errors, 'status')"
                    />
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import {TENANT_BASE_URL} from "../../../../common/Config/UrlHelper";

export default {
    name: "FinanceAdvancePaymentStatusModal",
    mixins: [FormHelperMixins, ModalMixin],
    props: {
        paymentId: {
            type: [Number, String],
            required: true,
        },
        currentStatus: {
            type: String,
            default: 'pending'
        }
    },
    data() {
        return {
            formData: {
                status: this.currentStatus || 'pending',
            },
            statusOptions: [
                {id: 'pending', name: this.$t('pending')},
                {id: 'confirm', name: this.$t('confirm')},
                {id: 'refund', name: this.$t('refund')},
                {id: 'cancel', name: this.$t('cancel')},
            ],
        }
    },
    methods: {
        submitData() {
            this.loading = true;
            this.errors = {};

            const payload = new FormData();
            payload.append('status', this.formData.status);
            payload.append('_method', 'PATCH');

            this.submitFromFixin('post', `${TENANT_BASE_URL}app/advance-payments/${this.paymentId}`, payload);
        },
        afterSuccess({data}) {
            $('#finance-advance-payment-status-modal').modal('hide');
            this.$emit('input', false);
            this.$emit('success');
            this.toastAndReload(data.message, 'finance-advance-payment-table');
        },
    }
}
</script>
